import { ActivatedRoute } from '@angular/router'
import { CommonModule, DatePipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { WorkOrderModel } from '../models/workOrder.model'
import { WorkOrderService } from '../workOrder.service'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { NavigationExtras, Router } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { WorkOrderItem } from '../models/workOrder_item.model'
import { AuthStateService } from '../../../auth-state.service'
import { MasterCommonServices } from '../../quotation/master.common.service'
import { InvoiceData } from '../../quotation/quotation_invoice_data'
import * as XLSX from 'xlsx'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import pdfMake from 'pdfmake/build/pdfmake'
import 'pdfmake/build/pdfmake.js'
import 'pdfmake/build/vfs_fonts.js'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { filter } from 'rxjs'
import { InvoiceService } from '../invoice.service'
@Component({
  selector: 'app-view-workOrders',
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule],
  templateUrl: './viewWorkOrder.component.html',
  styleUrls: ['./viewWorkOrder.component.css'],
  providers: [DatePipe],
})
export class ViewWorkOrderComponent implements OnInit {
  workOrderData: WorkOrderModel[] = []
  filteredWorkOrderData: WorkOrderModel[] = []
  filteredStageWorkOrderData: WorkOrderModel[] = []
  status: string = ''
  financialYears: string[] = []
  selectedFinancialYear: string = 'all'
  permissions: string[] = []
  stages: string[] = ['ongoing', 'rejected', 'completed', 'all']
  selectedStage: string = 'ongoing'
  workOrderCommonServices: MasterCommonServices | undefined

  filter = {
    woId: '',
    poId: '',
    date: '',
    workOrderCompany: '',
  }

  constructor(
    private datePipe: DatePipe,
    private masterCommonService: MasterCommonServices,
    private workOrderService: WorkOrderService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private authStateService: AuthStateService,
    private invoiceService: InvoiceService,
  ) {
    this.workOrderCommonServices = masterCommonService
    // this.route.paramMap.subscribe((params) => {
    //   this.status = params.get('status') || 'all'
    // })
    this.authStateService.permissions.subscribe((permList) => {
      this.permissions = permList
    })
  }
  ngOnInit(): void {
    if (this.masterCommonService.unitsList.length === 0) {
      this.masterCommonService.getAllUnits()
    }
    if (this.masterCommonService.clientsList.length === 0) {
      this.masterCommonService.getAllClients()
    }
    if (this.masterCommonService.partNumberList.length === 0) {
      this.masterCommonService.getAllPartNumbers()
    }
    this.getAllWorkOrders()
    this.performFinancialYearOperations()
  }

  filterByStage(): void {
    this.filteredStageWorkOrderData = this.workOrderData?.filter(
      (wo) =>
        this.selectedStage.toLowerCase() === 'all' ||
        // Rejected
        (this.selectedStage.toLowerCase() === 'rejected' &&
          (wo.workOrderFields.status === 'rejected' ||
            wo.workOrderFields.isDeleted)) ||
        // Ongoing (status ongoing OR null/empty) AND not deleted
        (this.selectedStage.toLowerCase() === 'ongoing' &&
          (wo.workOrderFields.status === 'ongoing' ||
            !wo.workOrderFields.status) &&
          !wo.workOrderFields.isDeleted) ||
        // Completed
        (this.selectedStage.toLowerCase() === 'completed' &&
          wo.workOrderFields.status === 'completed'),
    )

    this.filterByFinancialYear()
  }

  hasPermission(action: string): boolean {
    return this.permissions.includes(action)
  }

  applyFilters() {
  this.filteredWorkOrderData = this.filteredStageWorkOrderData
  this.filterByFinancialYear()

  this.filteredWorkOrderData = this.filteredWorkOrderData.filter((po) => {
    return (
      (!this.filter.woId ||
        po.workOrderFields.workOrderId
          ?.toString()
          .toLowerCase()
          .includes(this.filter.woId.toLowerCase())) &&

      (!this.filter.poId ||
        po.workOrderFields.purchaseOrderNumber
          ?.toString()
          .toLowerCase()
          .includes(this.filter.poId.toLowerCase())) &&

      (!this.filter.date ||
        new Date(po.workOrderFields.workOrderDate)
          .toLocaleDateString('en-GB')
          .includes(this.filter.date)) &&

      (!this.filter.workOrderCompany ||
        this.workOrderCommonServices
          ?.getClientName(po.workOrderFields.workOrderCompanyId)
          ?.companyName.toLowerCase()
          .includes(this.filter.workOrderCompany.toLowerCase()))
    )
  })
}

  isDeleted(po: WorkOrderModel): boolean {
    return po.workOrderFields.isDeleted === true
  }

  restoreWorkOrder(po: WorkOrderModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to restore this work order?' },
    })

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        po.workOrderFields.isDeleted = false
        this.workOrderService.updateWorkOrder(po).subscribe({
          next: (data: any) => {
            this.toastr.success('Work Order Restored Successfully!', 'Success')
            this.getAllWorkOrders()
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
  resetFilters(): void {
    this.filter = {
      woId: '',
      poId: '',
      date: '',
      workOrderCompany: '',
    }
    this.filteredWorkOrderData = this.filteredStageWorkOrderData
  }

  getAllWorkOrders(): void {
    this.masterCommonService.isLoading = true
    this.workOrderService.getAllWorkOrders().subscribe({
      next: (data: WorkOrderModel[]) => {
        

        this.workOrderData = data
        this.filterByStage()
        this.masterCommonService.isLoading = false
      },
      error: (error: any) => {
        this.masterCommonService.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  getWorkOrderId(id: number): string {
    const fullFinancialYear = this.getCurrentFinancialYear()
    const shortFinancialYear = this.getShortFinancialYear(fullFinancialYear)
    return `ATF/${id}/${shortFinancialYear}`
  }

  getShortFinancialYear(financialYear: string): string {
    const [startYear, endYear] = financialYear.split('-')
    return `${startYear.slice(-2)}-${endYear.slice(-2)}`
  }

  editWorkOrder(po: WorkOrderModel) {
    const navigationExtras: NavigationExtras = {
      state: {
        mode: 'update',
        workOrderFields: JSON.stringify(po.workOrderFields),
        workOrderItems: JSON.stringify(po.workOrderItems),
      },
    }
    this.router.navigate(['/editWorkOrder'], navigationExtras)
  }

  performFinancialYearOperations(): void {
    this.initializeFinancialYears()
    this.filterByStage()
  }

  initializeFinancialYears(): void {
    const currentYear = new Date().getFullYear()
    const currentFinancialYear = this.getCurrentFinancialYear()
    this.financialYears = [
      currentFinancialYear,
      `${currentYear - 1}-${currentYear}`,
      `${currentYear - 2}-${currentYear - 1}`,
      `${currentYear - 3}-${currentYear - 2}`,
      `${currentYear - 4}-${currentYear - 3}`,
    ]
  }

  getCurrentFinancialYear(): string {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth()
    return currentMonth >= 3
      ? `${currentYear}-${currentYear + 1}`
      : `${currentYear - 1}-${currentYear}`
  }

  filterByFinancialYear(): void {
    if (this.selectedFinancialYear === 'all') {
      this.filteredWorkOrderData = this.filteredStageWorkOrderData
    } else {
      const [startYear, endYear] = this.selectedFinancialYear
        .split('-')
        .map(Number)
      const startDate = new Date(startYear, 3, 1)
      const endDate = new Date(endYear, 2, 31)
      
      

      this.filteredWorkOrderData = this.filteredStageWorkOrderData.filter(
        (po) => {
          const workOrderDate = new Date(po.workOrderFields.workOrderDate)
          return workOrderDate >= startDate && workOrderDate <= endDate
        },
      )
    }
  }

  exportToExcel(): void {
    const dataToExport = this.filteredWorkOrderData.flatMap((po) => {
      return po.workOrderItems.map((item, index) => ({
        'Sr No': item.srNo,
        'Work Order No': po.workOrderFields.workOrderId,
        'Name of Party':
          this.workOrderCommonServices?.getClientName(
            po.workOrderFields.workOrderCompanyId,
          )?.companyName || '',
        'Purchase Order No': po.workOrderFields.purchaseOrderNumber,
        'PO Date': this.datePipe.transform(
          po.workOrderFields.workOrderDate,
          'dd/MM/yyyy',
        ),
        'Sr No.': item.srNo,
        'Part Code': this.masterCommonService.getPartNumberName(
          item.partNumberId ?? -1,
        )?.partName,
        Description: item.description,
        Unit: this.masterCommonService.getUnitName(item.unit)?.unitName || '-',
        'Order Qty': item.quantity,
        'Dispatched Quantity': item.dispatchedQuantity ?? 0,
        'Pending Quantity': Math.max(
          0,
          item.quantity - item.dispatchedQuantity,
        ),
      }))
    })

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport)
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Purchase Orders': worksheet },
      SheetNames: ['Purchase Orders'],
    }

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    })

    const data: Blob = new Blob([excelBuffer], {
      type: 'application/octet-stream',
    })
    const fileName = 'WorkOrders.xlsx'

    const link = document.createElement('a')
    link.href = URL.createObjectURL(data)
    link.download = fileName
    link.click()

    URL.revokeObjectURL(link.href)
  }

  deleteWorkOrder(workOrder: WorkOrderModel) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this work order?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.workOrderService.deleteWorkOrder(workOrder).subscribe({
          next: (response) => {
            this.toastr.success('Work Order Deleted Successfully!', 'Success')
            this.getAllWorkOrders()
            this.applyFilters()
          },
          error: (error) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }

  viewWorkOrder(workOrder: WorkOrderModel): void {
    this.invoiceService.generateInvoice(
      workOrder,
      this.masterCommonService,
      this.datePipe,
    )
  }
}
